import React, { FC } from "react";
import { Modal, Text } from "venice-ui";
import { t } from "../../helpers/userHelper";
import { dictionary } from "../../untils/dictionary"

interface IDeleteSpoolInstanceProps {
  handleCancel: () => any;
  handleDelete: (id: string) => void;
  id: string;
  isOpen: boolean;
}

export const DeleteSpoolInstance: FC<IDeleteSpoolInstanceProps> = ({
  handleCancel,
  handleDelete,
  id,
  isOpen,
}) => {

  return (
    <Modal
      title={t(dictionary.confirmDelete)}
      labelClose={t(dictionary.cancel)}
      handleClose={handleCancel}
      handleConfirm={() => handleDelete(id)}
      labelConfirm={t(dictionary.delete)}
      isOpen={isOpen}
      exitOnEsc={true}
    >
      <Text>{t(dictionary.doYouWantDeleteSpoolInstance)}</Text>
    </Modal>
  );
};
